'use strict';
/**
 * @param {KeyboardEvent} event
 *
 * @returns {boolean}
 */
function isAutofill(event) {
    return !event.cancelable;
}

module.exports = {
    isAutofill: isAutofill
};
